export default {
    payersNameContainer: {
        display: "inline-flex",
        flex: "1 1 0%",
        width: "80%",
    },
    formRow: {
        display: "flex",
        columnGap: "40px"
    },
    recipientsMiddleNameContainer: {
        marginLeft: '3%',
         marginRight: '3%', 
         width: '100%',
    },
    recipientFieldsContainer: {
        display: 'flex',
        flex: '1 1 0%',
         width: '80%',
    },
    recipientBatch1Container: {
        display: 'flex', 
        flexDirection: 'column', 
        width: '100%',
    },
    recipientBatch2Container: {
        display: 'flex', 
        flexDirection: 'column', 
        width: '100%',
        marginLeft: '3%',
    },

    recipientBatch3Container: {
        display: 'flex', 
        flexDirection: 'column', 
        width: '84%',
    },

    phoneNumberContainer: {
        display: "flex",
        alignItems: "flex-end",
        marginBottom: "30px",
        gap: "40px"
    },

    tinContainer: {
        display: "flex",
        rowGap: "20px",
        flexDirection: "column"
    },
    tinNotProvided: {
        display: "ruby"
    },
    tinNotProvidedContainer: {
        display: "flex",
        alignItems: "end",
        marginLeft: "1%"
    },
    tinNotProvidedLabelContainer: {
        marginLeft: "5px",
    }
    
}